import { render, staticRenderFns } from "./DiscountSelector.vue?vue&type=template&id=5c116dd0&"
import script from "./DiscountSelector.vue?vue&type=script&lang=js&"
export * from "./DiscountSelector.vue?vue&type=script&lang=js&"
import style0 from "./DiscountSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DiscountSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports